import { createFileRoute } from '@tanstack/react-router'
import { PainelPage } from '@/pages/painel/PainelPage'

export const Route = createFileRoute('/_auth/painel')({
  component: PainelPage,
})
